var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkkoPayActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EFF6E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_127_5589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_127_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 20H23V16H21.5V18.5H19V20ZM16 19C16.8333 19 17.5417 18.7083 18.125 18.125C18.7083 17.5417 19 16.8333 19 16C19 15.1667 18.7083 14.4583 18.125 13.875C17.5417 13.2917 16.8333 13 16 13C15.1667 13 14.4583 13.2917 13.875 13.875C13.2917 14.4583 13 15.1667 13 16C13 16.8333 13.2917 17.5417 13.875 18.125C14.4583 18.7083 15.1667 19 16 19ZM9 16H10.5V13.5H13V12H9V16ZM6 23V9H26V23H6Z",
    fill: "#6BB700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkkoPayActive);
export default __webpack_public_path__ + "static/media/okko-pay-active.97e6b80d67d159916c05a054d21a26dd.svg";
export { ForwardRef as ReactComponent };